var general = {
  initHeader: function() {
    var header_drawer = $('#header-drawer-popout');

    
    header_drawer.on('keyup', '.header-search-input', function(e) {
      if ($(this).val() != '') {
        $('.close-search').show();
      } else {
        $('.close-search').hide();
        $('.box-results').html('');
      }
    });
    header_drawer.on('click', '.close-search', function(e) {
      $('.close-search').hide();
      $('.header-search-input').val('');
      $('.box-results').html('');
    });
    $(document).on('click', 'body.drawer-visible [data-search-toggle]', function() {
      $('body').removeClass('showing-drawer drawer-visible');
      $('[data-drawer-toggle]').attr('aria-expanded', false);
    });

    
    $(document).on('click', '#drawer-navigation > .header-navigation-list > .header-navigation-list-item > .header-navigation-list-arrow', function(e) {
      $(this).toggleClass('menu-open');
    });
    $(document).on('click', '#drawer-navigation .header-navigation-list-header, #drawer-navigation .header-navigation-list-header > .header-navigation-list-arrow', function(e) {
      $(this).parents('.header-navigation-list-item').removeClass('open');
      $('.header-navigation-list-arrow').removeClass('menu-open');
      header_drawer.removeClass('menu-slide');
    });
    $(document).on('click', '.header-drawer.menu-slide', function(e) {
      e.preventDefault();
    });
    header_drawer.on('click', '.drawer-toggle', function(e) {
      setTimeout(function() {
        $('.header-navigation-list-arrow').removeClass('menu-open');
        header_drawer.removeClass('menu-slide');
      }, 1000);
    });
  },
  initHeaderScroll: function() {
    var H = 0;
    $(window).on('scroll', function() {
      var body = $('body');
      var header = $('#static-header');
      var h = $(this).scrollTop();
      
      if (h <= header.outerHeight()) {
        header.removeClass('scroll-top');
        header.removeClass('scroll-btm');
        body.removeClass('scroll-top');
        body.removeClass('scroll-btm');
        return false;
      }

      if ($('body').hasClass('template-product')) {
        var el_t = $('.module.module-product');
        var el_h = $('.product-wrap');
        if (el_t.length == 0) {
          el_t = $('.product-v3-details')
          el_h = $('.product-v3-details')
        }
        var cms = el_t.offset().top + el_h.outerHeight();
        if (H > h || h <= (cms - header.outerHeight() - 100)) {
          header.addClass('scroll-top');
          header.removeClass('scroll-btm');
          body.addClass('scroll-top');
          body.removeClass('scroll-btm');
        } else {
          header.removeClass('scroll-top');
          header.addClass('scroll-btm');
          body.removeClass('scroll-top');
          body.addClass('scroll-btm');
        }
      } else {
        if (H > h) {
          header.addClass('scroll-top');
          header.removeClass('scroll-btm');
          body.addClass('scroll-top');
          body.removeClass('scroll-btm');
        } else {
          header.removeClass('scroll-top');
          header.addClass('scroll-btm');
          body.removeClass('scroll-top');
          body.addClass('scroll-btm');
        }
      }

      H = h;
    });
  },
  initSearchbar: function() {
    var ajaxSearchbar = null;

    $(document).on('click', '[data-search-toggle]', function(e) {
      $('#site-search-v2').toggleClass('active');
      $('#site-search-v2 input[name="q"]')[0].focus();
      $('#site-search-v2 input[name="q"]').trigger('keyup');
      e.preventDefault();
    });
    $('#site-search-v2').on('click', '.search-bar-close', function() {
      $('#site-search-v2').removeClass('active');
      $('#site-search-v2 input[name="q"]')[0].blur();
    });
    $('#search-result-v2').on('click', '.search-bar input[name="q"]', function(e) {
      if ($(this).val() != '') $(this).trigger('keyup');
      e.preventDefault();
    });
    $(document).on('click', function(e) {
      var et = e.target,
          flag = true;

      if ($(et).parents('[data-search-toggle]').length > 0) {
        flag = false;
      } else if ($(et).attr('id') == 'site-search-v2') {
        flag = false;
      } else if ($(et).parents('#site-search-v2').length > 0) {
        flag = false;
      }

      if (flag) {
        $('#site-search-v2').removeClass('active');
        $('.search-bar .search-bar-result').removeClass('active');
      }
    });

    $('.search-bar > form[action*="/search"]').each(function() {
      var _t = $(this);
      var div = _t.parent();
      var input = $('input[name="q"]', _t);
        
      input.bind('keyup', function() {
        var result_box = $('.search-bar-result', div);
        result_box.removeClass('active');
        var section_empty = $('.search-bar-result-section-empty', div);
        section_empty.removeClass('active').html('');

        var term = $(this).val();
        if (term.length < 3) {
          $('.search-bar-result-section', result_box).removeClass('active').find('.row').html('');
          return false;
        }

        var form = $(this).closest('form');
        var search_url = form.attr('action');
        var search_type = $('input[name="type"]', form).val();
        var search_type_arr = search_type.split(',');
        var searcl_url_json = search_url + '/suggest.json?q=' + term + '&resources[type]=' + search_type + '&resources[limit]=4&resources[options][unavailable_products]=last&resources[options][fields]=title,variants.title,body';

        if (ajaxSearchbar != null) ajaxSearchbar.abort();

        ajaxSearchbar = $.getJSON(searcl_url_json, function(data) {
          var results = {};
          var result_count = 0;
          $.each(search_type_arr, function(i, type) {
            var key = type + 's';
            results[key] = data.resources.results[key];
            result_count += data.resources.results[key].length;
          });

          result_box.addClass('active');
          $('.search-bar-result-section', div).removeClass('active').find('.row').html('');

          if (result_count == 0) {
            var text = window.gpb.search.texts.no_results_v2_html.replace('[TERM]', term);
            section_empty.addClass('active').html(text);
            return false;
          }


          var section, row;
          
          section = $('.search-bar-result-section-products', div);
          results['products'].length == 0 ? section.removeClass('active') : section.addClass('active');
          row = $('.row', section);
          row.html('');
          $.each(results['products'], function (j, data) {
            if (j >= 4) return false;

            var price_html = data.price != '0.00' ? `<div class="price">
              ${Theme.moneyFormat.replace('{{amount}}', data.price)}
            </div>` : '';

            row.append(`<div class="col-md-3 col-6">
              <div class="search-bar-result-product">
                <div class="img">
                  <a href="${data.url}"><img src="${data.image}" alt="${data.title}"></a>
                </div>
                <div class="title">
                  <a href="${data.url}">${data.title}</a>
                </div>
                <div class="view-detail-action">
                  <a href="${data.url}">${collection.texts.view_details}</a>
                </div>
              </div>
            </div>`);
          });
          
          
          section = $('.search-bar-result-section-articles', div);
          results['articles'].length == 0 ? section.removeClass('active') : section.addClass('active');
          row = $('.row', section);
          row.html('');
          $.each(results['articles'], function (j, data) {
            if (j >= 2) return false;

            var date = data.published_at;
            var engine = new liquidjs.Liquid();
            engine
              .parseAndRender(`{{ date | date: "%b %d, %Y" }}`, {
                date: data.published_at
              })
              .then(function (date_html) {
                row.append(`<div class="col-md-6">
                  <div class="search-bar-result-article">
                    <div class="img">
                      <a href="${data.url}"><img src="${data.image}" alt="${data.title}"></a>
                    </div>
                    <div class="text">
                      <span class="date">${date_html}</span>
                      <a href="${data.url}">${data.title}</a>
                    </div>
                  </div>
                </div>`);
              });
          });
        });
      });
    });
  },
  initFooter: function() {
    var locator_btn = $('.locators > a');
    if (locator_btn.get(0)) {
      $('.drawer-store-locator-box a > span').html(locator_btn.get(0).innerText);
    }

    var newsletter = $('.footer-newsletter');
    if (newsletter.get(0)) {
      $('form', newsletter).validate({
        ignore: [],
        rules: {
          'contact[email]': {
            required: true,
            email: true,
          },
          'agree': {
            required: true,
          },
        },
        errorPlacement: function(error, element) {
          error.appendTo(element.parent())
        },
      })
    }
  },
  initLanguage: function() {
    if (typeof langify === 'undefined') return;
    
    var cur = langify.helper.getCurrentLanguage();
    $('.ly-languages-links-switcher-v2 > a').addClass(cur.toLowerCase());
    $('.ly-languages-links-switcher-v2 > div a[data-key="'+cur+'"]').remove();

    
    
    $('.ly-languages-links-switcher-v2 > a').on('click', function() {
      var div = $(this).next('div');
      var key = $('a', div).data('key');
      langify.helper.setCookie('ly-lang-selected', key, 365);
      window.location.href = $('a', div).attr('href');
    });
  },
  scrollTo: function(e) {
    var _t = $(this);
    var scroll_data = _t.data('scroll');
    var scroll_el = $(scroll_data);
    if (scroll_el.length > 0) {
      var t = scroll_el.offset().top;
      $('html, body').animate({
        scrollTop: t
      }, 800);
      e.preventDefault();
    }
  },
  copyText: function() {
    var _t = $(this);
    copyText(_t.text());

    _t.addClass('active');
    setTimeout(function() {
      _t.removeClass('active');
    }, 3000);
    
    function copyText(text) {
      copyTextToClipboard(text);
    }
    
    function fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;
      
      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
    
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
    
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
      } catch (err) {
      }
    
      document.body.removeChild(textArea);
    }
    
    function copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function() {
      }, function(err) {
      });
    }
  },
  getUrlVars: function() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      vars[key] = value;
    });
    return vars;
  },

  formatMoney: function(value) {
    value = value.toString();
    $.each(money_format.split('{{amount}}'), function(i, r) {
      if (r != '') {
        value = value.replace(r, "");
      }
    });
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return money_format.replace('{{amount}}', value);
  },
  
  decodeEntity: function(val) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = val;
    return textarea.value;
  },

  initShareButton: function() {
    var el = $('.gp-social > .gp-social-share');
    if (el.length == 0) return;

    var url = $('meta[property="og:url"]').attr('content');
    var title = $('meta[property="og:title"]').attr('content');
    var excerpt = $('meta[property="og:description"]').attr('content');

    var tpl = `
      <a href="https://facebook.com/sharer.php?u=${url}" target="_blank" class="social-media-link fab fa-facebook" rel="noopener noreferrer"></a> 
      <a href="https://twitter.com/share?url=?u=${url}" target="_blank" class="social-media-link fab fa-twitter" rel="noopener noreferrer"></a> 
      <a href="https://linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${excerpt}" target="_blank" class="social-media-link fab fa-linkedin" rel="noopener noreferrer"></a> 
      <a href="mailto:?subject=${title}%20&body=${excerpt}" target="_blank" class="social-media-link fas fa-envelope" rel="noopener noreferrer"></a> 
      <a href="${url}" data-success="${window.gpb.social.texts.url_copied}" target="_blank" class="social-media-link fa-copy-link copy-text" rel="noopener noreferrer">
          <span class="fas fa-link"></span>
          <span class="copy-text-content">${url}</span>
      </a>`

    el.html(tpl);

    el.on('click', 'a.social-media-link', function(e) {
      var _t = $(this);
      if (_t.hasClass('copy-text')) {
        _t.addClass('active');
        setTimeout(function() {
          _t.removeClass('active');
        }, 3000);
        e.preventDefault();
        return false;
      }
      return true;
    });
  },
}

var collection = {
  el_collection: null,
  texts: {
    sale: 'sale',
    new: 'new',
    trial_price: 'trial price',
    view_details: 'View details',

    add_to_cart: '<img src="//de.gpbatteries.com/cdn/shop/t/30/assets/icon-add-to-cart-green.png?v=165195017460271335061709088918" alt="">',
    sold_out: 'Sold out',
    quantity: 'Quantity',
  },
  initDataProducts: function(classname, handlebars_id, section_id) {
    classname = classname || 'div[data-product]';
    handlebars_id = handlebars_id || '#tpl-product-item';
    section_id = section_id || '#shopify-section-static-collection-v2';

    var el_products = $(classname);

    if (el_products.length == 0) return;
    else if (typeof Handlebars === 'undefined') return;
  
    Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
      switch (operator) {
        case '==':
          return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case '===':
          return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '!=':
          return (v1 != v2) ? options.fn(this) : options.inverse(this);
        case '!==':
          return (v1 !== v2) ? options.fn(this) : options.inverse(this);
        case '<':
          return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case '<=':
          return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case '>':
          return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case '>=':
          return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case '&&':
          return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case '||':
          return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
          return options.inverse(this);
      }
    });

    Handlebars.registerHelper('money', function (value) {
      return general.formatMoney(value);
    });

    var money_format = "",
        el_section = $(section_id),
        hb_template = Handlebars.compile($(handlebars_id).html()), 
        locale = '';

    locale = locale != '' && locale === 'true' ? '' : '';

    var product_count = el_products.length;
    el_products.each(function() {
      var _t = $(this),
          handle = _t.data('product');
      
      collection.getDataProduct(handle).then(function(data) {
        data = JSON.parse(data);
        data.texts = collection.texts;

        _t.html(hb_template(data));
      }).fail(function(err) {
        _t.remove();
      }).then(function() {
        product_count--;
        if (product_count == 0) {
          collection.el_collection = el_section;
          collection.initCollectionProduct();
          collection.initCollectionProductActions();
        }
      });
    });
  },
  getDataProduct: function(handle) {
    var locale = '';

    locale = locale != '' && locale === 'true' ? '' : '';

    return $.get(`${locale}/products/${handle}?view=api`);
  },

  initCollectionProduct: function() {
    $('.product-options .single-option-selector option', collection.el_collection).each(function() {
      var _t = $(this);
      var val = _t.val();
      var wrapper = _t.parents('.product-options');

      var real_option = $(wrapper).find('.product-select option[data-title="'+ val +'"]')
      
      var dataPrice = real_option.data('price');
      var dataCompareAtPrice = real_option.data('compare_at_price');
      var dataPriceSave = real_option.attr('price_save');
      var dataSlQty = real_option.data('quantity');
      var dataVariantId = real_option.data('variant-id');

      _t.attr('data-price', dataPrice);
      _t.attr('data-compare_at_price', dataCompareAtPrice);
      _t.attr('data-price_save', dataPriceSave);
      _t.attr('data-quantity', dataSlQty);
      _t.attr('data-variant', dataVariantId);
    });
    $('.product-list-item', collection.el_collection).each(function() {
      var _t = $(this),
          variant = _t.data('variant');

      if (typeof variant === 'undefined' || variant == '') return;

      var real_option = $('.product-select option[value="'+variant+'"]', _t);

      if (real_option.length == 0) return;

      $('.product-select', _t).val(variant).trigger('change');
      $('.single-option-selector', _t).val(real_option.attr('data-title')).trigger('change');
      $('.list-title > a', _t).append(` - ${real_option.attr('data-title')}`);
      $('.group-option', _t).hide();
    });

    $('.product-options .single-option-selector', collection.el_collection).each(collection.onChangeProductOption);
  },
  initCollectionProductActions: function() {collection.el_collection.on('click', '.number-input-nav-item', function() {
      var _t = $(this);
      var plus = _t.hasClass('icon-plus');
      var minus = _t.hasClass('icon-minus');
      var wrapper = _t.parents('.list-item');
      var quantity = wrapper.find('input[name="quantity"]');
      var val = quantity.val();

      if (plus) {
        val++;
        var inventory_quantity = quantity.attr('data-quantity');
        if (val > inventory_quantity) val = inventory_quantity;
      } else if (minus) {
        val--;
        if (val <= 0) val = 1;
      }

      quantity.val(val);
    });collection.el_collection.on('keyup', 'input.quantity', function() {
      var _t = $(this);
      var val = _t.val();
      var inventory_quantity = _t.data('quantity');

      if (val > inventory_quantity) val = inventory_quantity;
      else if (val <= 0) val = 1;

      _t.val(val);
    });collection.el_collection.on('click', '.list-options .select-pill-wrapper button', collection.onClickProductOption);
    
    collection.el_collection.on('change', '.product-options .single-option-selector', collection.onChangeProductOption);
  },
  onClickProductOption: function() {
    var _t = $(this);
    var wrapper = _t.parents('.list-item');
    _t.addClass('active').siblings().removeClass('active');

    var option_index = _t.parent().index();

    $('.product-options .selector-wrapper:nth-child('+(option_index+1)+') .single-option-selector', wrapper)
      .val(_t.data('value'))
      .trigger('change');
  },
  onChangeProductOption: function() {
    var _t = $(this);
    var wrapper = _t.parents('.list-item');
    var selected_option = $('option:selected', _t);
    var real_select = wrapper.find('.product-select');
    var quantity_input = wrapper.find('.quantity');
    var submit_btn = wrapper.find('.add-to-cart-button');var dataPrice = selected_option.data('price').toString();
    var dataCompareAtPrice = selected_option.data('compare_at_price').toString();      
    var el_dataPrice = $(wrapper).find('.price > .money:not(.original)');
    var el_dataPriceCompare = $(wrapper).find('.price > .original');
    var init_dataPrice = parseFloat(dataPrice.replace(/[^0-9]/g,''));
    var init_dataPriceCompare = parseFloat(dataCompareAtPrice.replace(/[^0-9]/g,''));
    if (init_dataPriceCompare > init_dataPrice) {
      if (el_dataPriceCompare.length == 0) {
        el_dataPriceCompare = $('<span/ >').addClass('original money');
        $(wrapper).find('.price').prepend(el_dataPriceCompare);
      }
      el_dataPriceCompare.text(general.formatMoney(dataCompareAtPrice));
    } else {
      el_dataPriceCompare.text('');
    }
    el_dataPrice.text(general.formatMoney(dataPrice));var dataVariantId = selected_option.data('variant');
    var el_images = $(wrapper).find('img.list-image');
    var el_image_first = $(wrapper).find('img.list-image:first-child');
    var el_image = $(wrapper).find('img.list-image-'+dataVariantId);
    el_images.addClass('hidden');
    if (el_image.length > 0) {
      el_image.removeClass('hidden');
    } else {
      el_image_first.removeClass('hidden');
    }var real_selected_option = $('option[value="'+dataVariantId+'"]', real_select);
    if (real_selected_option.length > 0) {real_select.val(dataVariantId);var qty = quantity_input.val();
      var inventory_quantity = real_selected_option.data('quantity');
      quantity_input.attr('data-quantity', inventory_quantity || 1);
      if (qty > inventory_quantity) {
        quantity_input.val(1);
      }submit_btn.html(collection.texts.add_to_cart).show()
        .addClass('inverse')
        .removeClass('disabled')
        .removeAttr('disabled')
        .parents('.group-form').removeClass('disabled')
        ;
    } else {
      quantity_input.val(1);submit_btn.html(collection.texts.sold_out).show()
        .addClass('disabled')
        .removeClass('inverse')
        .attr('disabled', 'disabled')
        .parents('.group-form').addClass('disabled')
        ;
    }
    
    _t.prev().html(_t.val());
  }
}

var products = {
  initVideoHtml5: function() {
    var button = 'button.video-html5-p_video';
    var video = 'video.video-html5-p_video';
    var canvas = 'canvas.video-html5-p_video';

    $(button).on('click', function() {
      $(button).parents('.video-overlay').hide();
      $(video).attr('controls', true);
      $(video).get(0).play();
    });

    $(video).on('pause', function() {
      $(button).parents('.video-overlay').show();
      $(video).removeAttr('controls');
    });
    
    $(video).on('ended', function() {
      $(button).parents('.video-overlay').show();
      $(video).removeAttr('controls');
    });
  }
}

$(function() {
  general.initHeader();
  general.initHeaderScroll();
  general.initSearchbar();
  general.initFooter();
  general.initLanguage();
  general.initShareButton();
  products.initVideoHtml5();
  $('.copy-text').on('click', general.copyText);
  $('[data-scroll]').on('click', general.scrollTo);

  $(window).on('load', function() {
    $('a').on('click', function(e) {
      var href = $(this).attr('href');
      if (href.charAt(0) != '#') return true;

      var el = $(href);
      if (el.length == 0) return true;

      $('html, body').stop().animate({
        scrollTop: el.offset().top
      }, 800);
    });
  });
});